ACC.mergecarts = {

    _autoload: [],

    openMergeCartsModalTrigger(btn) {
        $modal.open(btn);
    },

    openMergeCartsModal() {
        const showMergeCartsTrigger = $('#showMergeCartsTrigger');
        if (showMergeCartsTrigger.length) {
            showMergeCartsTrigger.click();
        }
    },
};
